<ng-container *ngIf="{ title: title$ | async, leftBtn: leftBtn$ | async, rightBtn: rightBtn$ | async } as data">
  <div class="section countryNotification"
       id="countryNotificationBottom"
       data-cy="country-bar"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div>
            <button (click)="close(false, !!data?.leftBtn?.navigate ? data?.rightBtn?.country : data?.leftBtn?.country)"
                    class="country-close country-link stay-at"
                    data-cy="country-bar-close-btn"
                    data-event-action="Entered on DE"
                    data-event-category="Country Overlay Bottom"
                    data-event-label="Close Overlay"
            >
            <span>
              <img [alt]="'shared.close' | cxTranslate"
                   [title]="'shared.close' | cxTranslate"
                   class="icon-close"
                   src="../../../assets/images/Icon_close_dark.svg"
              />
            </span>
            </button>
            <p [innerHTML]="data?.title | safeHtml"
               data-cy="country-bar-title"
               mbCmsInnerHTML
            ></p>
          </div>
          <div class="row">
            <div class="col-lg-6 col-xs-12">
              <button [attr.data-event-action]="data?.leftBtn?.eventAction ?? ''"
                      [attr.data-event-label]="data?.leftBtn?.eventLabel ?? ''"
                      [ngClass]="data?.leftBtn?.class ?? ''"
                      (click)="close(data?.leftBtn?.navigate, data?.leftBtn?.country)"
                      class="btn btn-primary country-link"
                      data-cy="country-bar-left-btn"
                      data-event-category="Country Overlay Bottom"
              >
                <span [innerHTML]="data?.leftBtn?.text ?? '' | safeHtml"
                      data-cy="country-bar-left-btn-text"
                      mbCmsInnerHTML
                ></span>
                <span>
                  <img [alt]="data?.leftBtn?.alt ?? ''"
                       [title]="data?.leftBtn?.title ?? ''"
                       [src]="'../../../assets/images/country-icons/country.' + (data?.leftBtn?.country ?? '') + '.svg'"
                       class="flag"
                       data-cy="country-bar-left-btn-icon"
                       data-icon="country"
                  />
                </span>
              </button>
            </div>
            <div class="col-lg-6 col-xs-12 text-inverted">
              <button [attr.data-event-action]="data?.rightBtn?.eventAction ?? ''"
                      [attr.data-event-label]="data?.rightBtn?.eventLabel ?? ''"
                      [ngClass]="data?.rightBtn?.class ?? ''"
                      (click)="close(data?.rightBtn?.navigate, data?.rightBtn?.country)"
                      class="btn btn-secondary country-link country-bar-right-btn"
                      data-cy="country-bar-right-btn"
                      data-event-category="Country Overlay Bottom"
              >
                <span [innerHTML]="data?.rightBtn?.text ?? '' | safeHtml"
                      data-cy="country-bar-right-btn-text"
                      mbCmsInnerHTML
                ></span>
                <span>
                  <img [alt]="data?.rightBtn?.alt ?? ''"
                       [title]="data?.rightBtn?.title ?? ''"
                       [src]="'../../../assets/images/country-icons/country.' + (data?.rightBtn?.country ?? '') + '.svg'"
                       class="flag"
                       data-cy="country-bar-right-btn-icon"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

